<div class="ickahra kareli">
  <div class="sar">
    <p class="etiket">Kurumsal firmalar</p>
    <h1 class="h1" style="margin-top:16px">Eğitim bitti. <span class="vurgu">Altı ay sonra</span> ne kaldı?</h1>
    <p class="giris-p">Zorunlu eğitimlerin tamamlanma oranını herkes ölçer. pratiu, eğitimden aylar sonra çalışanın gerçekten neyi hatırladığını ölçer ve unutulanı kendiliğinden tazeler.</p>
    <div class="hero-btn">
      <a class="btn kirmizi" href="https://app.pratiu.com" target="_blank" rel="noopener">Hemen kayıt olun <svg><use xlink:href="#i-ok"></use></svg></a>
      <a class="btn ikincil" routerLink="/contact">Satışla görüşün</a>
    </div>
    <div class="sayac">
      <div><span class="sayi">4 dk</span><span class="etiket">haftalık çalışan yükü</span></div>
      <div><span class="sayi">%90</span><span class="etiket">90. günde hatırlama hedefi</span></div>
      <div><span class="sayi">SSO</span><span class="etiket">kurumsal kimlik entegrasyonu</span></div>
    </div>
  </div>
</div>

<div class="sar bol">
  <div class="aciklama">
    <div>
      <span class="etiket">Kullanım alanları</span>
      <h2 class="h2" style="margin:14px 0 18px">Tazelik gerektiren her prosedür.</h2>
      <p>İş sağlığı ve güvenliği kuralları, kalite prosedürleri, ürün bilgisi, mevzuat değişiklikleri, bilgi güvenliği farkındalığı. Bunların ortak yanı: yılda bir anlatılıp yıl boyu hatırlanması beklenmesi.</p>
      <p>pratiu bu içerikleri kısa sorulara böler ve çalışanın unutma eşiğine göre dağıtır. Haftada birkaç dakika, tam ihtiyaç anında.</p>
    </div>
    <div>
      <span class="etiket">Firmanın aldığı</span>
      <ul class="tik" style="margin-top:16px">
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Yetkinlik kırılımı</b> — departman ve rol bazında zayıf konu listesi.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Denetime hazır kayıt</b> — kim neyi ne zaman doğru bildi, tarihçesiyle.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Mevzuat güncellemesi</b> — kural değişince ilgili sorular otomatik yeniden dağıtılır.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Sessiz mod</b> — yıllık izin ve vardiya takvimine göre soru göndermeme.</span></li>
      </ul>
    </div>
  </div>
</div>

<div style="border-top:1px solid var(--cizgi)">
  <div class="sar bol ince">
    <div class="oz-liste">
      <div><span class="etiket">01</span><h4 class="h4">Periyodik bilgi ölçümü</h4><p>Çalışanların bilgi düzeyini tek seferlik değil, sürekli değerlendirin.</p></div>
      <div><span class="etiket">02</span><h4 class="h4">Performans analizleri</h4><p>Gelişim ihtiyacı olan konu ve ekipleri veriyle belirleyin.</p></div>
      <div><span class="etiket">03</span><h4 class="h4">Geri bildirim döngüsü</h4><p>Çalışan yanlış yaptığı anda doğru bilgiyi görsün.</p></div>
      <div><span class="etiket">04</span><h4 class="h4">Eğitim programı güncelleme</h4><p>Sonuçlara göre eğitim içeriğini nokta atışı revize edin.</p></div>
    </div>
  </div>
</div>

<div class="cta">
  <div class="cta-ic">
    <div><h2 class="h2">Pilot ekiple başlayın.</h2><p>Tek departman, tek prosedür, dört hafta. Sonucu birlikte görelim.</p></div>
    <a class="btn kirmizi" routerLink="/contact">Pilot başlatın <svg><use xlink:href="#i-ok"></use></svg></a>
  </div>
</div>
